/**
 * Created by Qingger Corp.
 * User:
 * Date: 2019/9/18
 * Time: 19:44
 * Desc: 营销中心-秒杀活动-新增/编辑
 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import type { ElForm } from "element-ui/types/form";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import { groupBy } from "lodash";
import { client } from "rsui-core/lib/post-message";
import { appEnvConfig } from "@/configs/appConfigs";
import { EmpServiceAPIActions } from "@/services/empService";
import { IPSService } from "@/services/ipsServices";
import IPSDatePicker from "@/views/components/ips-date-picker";
import Sketch from "@/views/components/sketch";
import selectGoods from "@/views/components/selectGoods";
import ProductItem from "@/views/components/productItem/productItem.vue";
import Upload from "@/views/components/upload/upload.vue";
import ImgPreview from "@/views/components/imgPreview";
import baseAPIService from "@/services/base/baseAPIService";
import importBatchSet from "@/views/components/importBatchSet";
import { flatten, noop } from "@/util";
import { Functions } from "@/library/utils/functions";
import AddPrimarySite from "@/views/components/addSite";
import NewSelectSite from "@/views/components/newSelectSIte";
interface receiptConfigObj {
	type: number; // 0所有会员均可参与 1指定参与条件
	id: string; // 指定参与条件中的会员参与ID
	note: string; // 不满足条件的提示信息
}
interface dispalyConfigObj {
	isCountdown: number; // 秒杀倒计时 0不展示 1展示
	tagName: string; // 标签文字
	tagBackPic: string; // 价签底图
}
interface ISecKillForm {
	skId?: string;
	actBeginTime: string | number;
	shareCardPicture: string;
	actEndTime: string | number;
	list: any[];
	actImage: string;
	secKillName: string;
	remindTime: number;
	productImages: string[];
	siteCodes: any[];
	qikanImage: string;
	state: number;
	beforeBeginTime: string | number;
	isOpenCommission: number;
	bdProductCode: string;
	sharePicture: string;
	_qikanShow?: boolean;
	buttonName?: string;
	_actShow?: boolean;
	pointsType?: number;
	shippingState?: number;
	isCanReturnGoods?: number; // 是否支持退货 0不支持 1支持
	receiptConfig?: receiptConfigObj;
	displayConfig?: dispalyConfigObj;
}

@Component({
	components: {
		IPSDatePicker,
		Sketch,
		ProductItem,
		Upload,
		AddPrimarySite,
	},
})
export default class SeckillEdit extends Vue {
	$refs: {
		Sketch: Sketch;
		secKillForm: ElForm;
		productItem: ProductItem;
	};
	public condition: any = {
		id: "",
		text: "",
	};
	excelHeader = [
		{ header: "货号", key: "productCode", width: 15 },
		{ header: "条码", key: "sku", width: 20 },
		{ header: "规格", key: "specVal", width: 10 },
		{ header: "秒杀价(元)", key: "price", width: 40 },
		{ header: "库存", key: "stock", width: 40 },
	];

	//  预览组件的参数

	componentKeys = ["secKill", "shareCard", "sharePoster"];
	platformVersion: number;

	get componentData() {
		return [
			this.selectGoodsType === 2 ? this.seckillForm.list[0].brProducts[0] : this.seckillForm.list[0],
			{ img: this.seckillForm.shareCardPicture, title: this.seckillForm.secKillName },
			{ img: this.seckillForm.sharePicture, title: this.seckillForm.secKillName },
		];
	}

	//  a. 预热开始前，所有内容均可修改；
	// d. 秒杀结束后，所有内容均不可修改；
	get disableState() {
		const state = +this.$route.params.state;
		return this.isCopy ? false : !this.operAuthority || state > 2;
	}

	// c. 秒杀开始后，【预热开始时间】、【秒杀开始时间】、【活动商品】、所有【购买规则】不可修改，其他均可修改
	get otherState() {
		const state = +this.$route.params.state;
		return this.isCopy ? false : !this.operAuthority || state > 1;
	}
	// 预热开始后，【预热开始时间】、【活动商品】不可再修改；
	get editState() {
		return this.isCopy ? false : this.$route.params.state !== "0" || !this.operAuthority;
	}

	get editStockState() {
		return this.isCopy ? true : (this.$route.params.state === "0" || this.$route.params.state === "1" || this.$route.params.state === "2") && this.operAuthority;
	}

	/**
	 * 秒杀活动Id
	 * @type {number}
	 */
	@Prop({ default: 0 }) skId: number;

	/**
	 * 图片上传地址
	 * @type {string}
	 */
	public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	siteId = 0;

	/**
	 * token
	 * @type {{Authorization: string}}
	 */
	public tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	/**
	 * 图片放大弹窗是否显示
	 * @type {boolean}
	 */
	public isMagnifyPopShow = false;

	/* 图片上传地址 */
	public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	/**
	 * corpId
	 */
	public corpId = baseAPIService.resolveCorpId();

	/**
	 * 添加活动列表
	 * @type {ItemObject}
	 */
	public seckillForm: ISecKillForm = {
		secKillName: "",
		beforeBeginTime: "",
		remindTime: 0,
		actBeginTime: "",
		actEndTime: "",
		qikanImage: "",
		actImage: "",
		shareCardPicture: "",
		sharePicture: "",
		state: 1,
		siteCodes: [],
		bdProductCode: "",
		buttonName: "立即秒杀",
		list: [],
		productImages: [],
		_qikanShow: true,
		_actShow: true,
		pointsType: 1,
		shippingState: 0,
		isOpenCommission: 0,
		isCanReturnGoods: 1, // 是否支持退货 0不支持 1支持
		receiptConfig: {
			type: 0,
			id: null,
			note: "您暂时无法参与本秒杀",
		},
		displayConfig: {
			isCountdown: 1,
			tagName: "秒杀价",
			tagBackPic: "https://ssl-picture.tenyun.runsasoft.com/17c653c021ee11edbc6f9f0cd6b88bcb.png",
		},
	};

	public rules = {
		secKillName: [{ required: true, message: "请输入秒杀活动名称", trigger: "change" }],
		buttonName: [{ required: true, message: "请输入秒杀按钮文字", trigger: "change" }],
		siteCodes: [{ required: true, message: "请选择适用网点", trigger: "change" }],
		beforeBeginTime: [{ required: true, message: "请选择预热开始时间", trigger: "change" }],
		actBeginTime: [{ validator: this.VActBeginTime, trigger: "change" }],
		actEndTime: [{ validator: this.VActEndTime, trigger: "change" }],
		remindTime: [{ required: true, message: "请输入秒杀开始前时间", trigger: "change" }],
		list: [{ required: true, message: "请添加活动商品", trigger: "change" }],
		productImages: [{ required: true, message: "请选择秒杀图片", trigger: "change" }],
		shareCardPicture: [{ required: true, message: "请选择分享卡片封面", trigger: "change" }],
		sharePicture: [{ required: true, message: "请选择分享海报封面", trigger: "change" }],
		"receiptConfig.note": [{ required: true, message: "请输入无法参与用户提示", trigger: "change" }],
		"receiptConfig.id": [{ required: true, message: "请选择限制条件", trigger: "change" }],
		"displayConfig.tagName": [{ required: true, message: "请输入价签文字", trigger: "change" }],
	};

	VActBeginTime(rule, value, callback) {
		const remindTime = moment(this.seckillForm.beforeBeginTime).unix();
		if (!value) {
			callback(new Error("请选择秒杀活动开始时间"));
		} else if (moment(value).unix() <= remindTime || moment(this.seckillForm.actBeginTime).unix() <= remindTime) {
			callback(new Error("活动开始时间需大于预热开始时间"));
		} else if (this.seckillForm.actEndTime && moment(value).unix() > moment(this.seckillForm.actEndTime).unix()) {
			callback(new Error("活动开始时间不能大于活动结束时间"));
		} else {
			callback();
		}
	}
	VActEndTime(rule, value, callback) {
		const remindTime = moment(this.seckillForm.beforeBeginTime).unix();
		if (!value) {
			callback(new Error("请选择秒杀活动结束时间"));
		} else if (moment(value).unix() <= remindTime || moment(this.seckillForm.actEndTime).unix() <= remindTime) {
			callback(new Error("活动结束时间需大于预热开始时间"));
		} else if (this.seckillForm.actBeginTime && moment(value).unix() <= moment(this.seckillForm.actBeginTime).unix()) {
			callback(new Error("活动结束时间不能小于活动开始时间"));
		} else {
			callback();
		}
	}
	changeEndDate() {
		if (this.seckillForm.actEndTime <= this.seckillForm.actBeginTime) {
			this.$message.error("活动结束时间不能小于活动开始时间！");
			this.seckillForm.actEndTime = "";
			return;
		}
	}
	openSelectSiteDialog(code) {
		// 沈总说换成单网点选择
		// code为0则为选择网点，为1是查看网点
		new NewSelectSite()
			.open({
				sgId: +this.$route.params.sgId || +this.$route.params.id,
				selectCodes: this.seckillForm.siteCodes,
				readonly: !code,
			})
			.then((val: string[]) => {
				if (val.length > 1) {
					this.$message.error("秒杀只能选择单网点");
					return;
				}
				this.seckillForm.siteCodes = val;
			}, noop);
	}

	/**
	 * 时间选择控制
	 * @return null
	 * @desc 当前时间控制到今天
	 */
	public pickerOptions: ItemObject = {
		disabledDate(time) {
			return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
		},
	};

	/**
	 * 错误图片
	 */
	public errorImg: any = require("../../../../static/img/bg_pic.png");

	// 选择商品的类型
	public selectGoodsType: 1 | 2 = 1;

	// 传给预览的参数
	public goodsInfo = null;

	// 是否有权限 1 有权限0 没有
	public operAuthority = 1;

	// 是否是复制的秒杀活动 1是 0否

	public isCopy = 0;

	/* 方法 */

	@Watch("seckillForm.list")
	onGoodsListChange(n, o) {
		if (n && n !== o) {
			if (this.selectGoodsType === 1) {
				this.goodsInfo = n[0];
				if (n[0].productImages && n[0].productImages.length) {
					this.seckillForm.productImages = n[0].productImages;
				}
			} else {
				this.goodsInfo = n[0].brProducts[0];
				if (this.goodsInfo.productImages && this.goodsInfo.productImages.length) {
					this.seckillForm.productImages = this.goodsInfo.productImages;
				}
			}
		}
	}

	@Watch("seckillForm.productImages")
	onProductimagesChange(n, o) {
		if (n && n !== o) {
			if (this.selectGoodsType === 1) {
				this.seckillForm.list[0].productImages = this.seckillForm.productImages;
			} else {
				this.seckillForm.list[0].brProducts[0].productImages = this.seckillForm.productImages;
			}
		}
	}
	public uploadPricePic(res: any): void {
		this.seckillForm.displayConfig.tagBackPic = res;
	}
	public uploadActivityPicSuccess(res: any): void {
		this.seckillForm.productImages = res;
	}

	public uploadShareCardPictureSuccess(res: any): void {
		this.seckillForm.shareCardPicture = res.content;
		this.seckillForm.actImage = res.content;
	}

	public uploadSharePictureSuccess(res: any): void {
		this.seckillForm.sharePicture = res.content;
		this.seckillForm.qikanImage = res.content;
	}

	/**
	 * 图片上传失败
	 * @return null
	 */
	public uploadImgError(): void {
		this.$message.error("图片上传失败");
	}

	/**
	 * 图片上传之前
	 * @param {ItemObject} file
	 * @return boolean
	 */
	public onBeforeUpload(file: ItemObject): boolean {
		const isJpg = file.type === "image/jpeg";
		const isPng = file.type === "image/png";
		const isGif = file.type === "image/gif";
		const LtSize = file.size / 1024 <= 1024;
		if (!isJpg && !isPng && !isGif) {
			this.$message.error("上传图片只能是 JPG/JPEG/PNG/GIF 格式!");
		}
		if (!LtSize) {
			this.$message.error("上传图片大小不能超过 1M!");
		}
		return (isJpg || isPng || isGif) && LtSize;
	}

	/**
	 * 获取秒杀活动详情
	 * @return null
	 */
	public getSecKillDetail(): void {
		const postParams = {
			skId: Number.parseInt(this.$route.params.id),
		};
		IPSService.secKillInfo({ postParams }).then((res: any) => {
			const resp = res;
			this.operAuthority = res.operAuthority;
			if (this.isCopy) {
				resp.beforeBeginTime = "";
				resp.actBeginTime = "";
				resp.actEndTime = "";
			} else {
				resp.beforeBeginTime = moment(resp.beforeBeginTime * 1000);
				resp.actBeginTime = moment(resp.actBeginTime * 1000);
				resp.actEndTime = moment(resp.actEndTime * 1000);
			}

			// 版单号处理
			if (this.selectGoodsType === 2) {
				const list: any = [{}];
				list[0].bdCode = resp.bdProductCode;
				list[0].brProducts = resp.list;
				list[0].brProducts[0].productImages = res.productImages;
				resp.list = list;
			} else {
				resp.list[0].productImages = res.productImages;
			}
			resp._actShow = !!res.actImage;
			resp._qikanShow = !!res.qikanImage;

			this.seckillForm = resp;
			this.siteId = resp.siteCodes[0].siteId;
			this.seckillForm.siteCodes = res.siteCodes.map((i) => i.siteCode);
			this.isCopy && this.getStock(resp.list);
			if (resp.receiptConfig.type == 1 && resp.receiptConfig.id) {
				this.condition.id = resp.receiptConfig.id;
				this.getConditionText();
			}
			this.$nextTick(() => {
				this.$refs.Sketch.$forceUpdate();
			});
		});
	}

	// 商品库存选择

	public getStock(list = []) {
		if (list && list.length) {
			let code = [];
			if (this.selectGoodsType === 1) {
				code = list.map((i) => i.productCode);
			} else {
				code = list[0].brProducts.map((i) => i.productCode);
			}
			const postParams = { productCodes: code, siteCode: this.seckillForm.siteCodes.join() };
			IPSService.searchProductList({ postParams })
				.then((result: any) => {
					if (this.selectGoodsType === 1) {
						this.seckillForm.list = list.map((i) => {
							i.skuItems.map((v) => {
								result.list[0].skuItems.forEach((item) => {
									if (item.goodsSku === v.sku) {
										v.stock = item.stock;
									}
								});
								return v;
							});
							return i;
						});
					} else {
						const secList = list[0].brProducts.map((i) => {
							result.list.forEach((v) => {
								if (i.productCode === v.productCode) {
									i.skuItems.map((item) => {
										v.skuItems.forEach((item2) => {
											if (item.sku === item2.goodsSku) {
												this.$set(item, "stock", item2.stock);
											}
										});
										return item;
									});
								}
							});
							return i;
						});
						this.seckillForm.list = [
							{
								bdCode: list[0].bdCode,
								brProducts: secList,
							},
						];
					}
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}

	/**
	 * 获取商品信息
	 * @return null
	 */
	public onGetProductInfo(): void {
		if (!this.seckillForm.siteCodes) {
			this.$message.warning("请先选择网点！");
			return;
		}
		selectGoods.open({ multiple: false, title: "添加商品" }).then((res) => {
			this.selectGoodsType = res.type;
			if (res.type === 2) {
				this.seckillForm.productImages = flatten(
					res.list.map((i) => {
						return i.brProducts.map((v) => {
							return v.productImages;
						});
					}),
				);
				this.seckillForm.list = res.list;
			}
			this.getStock(res.list);
		});
	}

	/**
	 * 新增/编辑秒杀活动
	 * @return null
	 */
	public onSaveSeckillConfig(): void {
		this.$refs.secKillForm.validate((res) => {
			if (res) {
				this.seckillForm.list = this.seckillForm.list.map((v) => {
					v.isOpenCommission = Number(v.isOpenCommission);
					return v;
				});
				const seckillFormData = cloneDeep(this.seckillForm);
				let flag = false;
				seckillFormData.list && (flag = seckillFormData.list.every(this.validateIsEdit));
				if (flag) {
					this.$message.warning("当前页面存在未保存数据，请保存后再发布!");
					return false;
				}
				const id = this.isCopy ? "0" : this.$route.params.id;
				const loading = this.$loading({
					lock: true,
					text: "请稍等...",
					spinner: "el-icon-loading",
					background: "rgba(225,225,225,0.3)",
				});

				// 单独的图片判断
				if (seckillFormData._actShow && !seckillFormData.actImage) {
					this.$message.error("请选择图片");
					return;
				}
				if (seckillFormData._qikanShow && !seckillFormData.qikanImage) {
					this.$message.error("请选择图片");
					return;
				}
				// 未勾选，去掉展示配置的图片
				if (!seckillFormData._actShow) {
					seckillFormData.actImage = "";
				}
				if (!seckillFormData._qikanShow) {
					seckillFormData.qikanImage = "";
				}

				seckillFormData.beforeBeginTime = moment(seckillFormData.beforeBeginTime).unix();
				seckillFormData.actBeginTime = moment(seckillFormData.actBeginTime).unix();
				seckillFormData.actEndTime = moment(seckillFormData.actEndTime).unix();

				// 版单号处理
				if (this.selectGoodsType === 2) {
					seckillFormData.bdProductCode = seckillFormData.list[0].bdCode;
					seckillFormData.list = seckillFormData.list[0].brProducts;
				} else {
				}
				if (id !== "0") {
					seckillFormData.skId = id;
				}
				(id === "0" ? IPSService.secKillAdd : IPSService.secKillSave)({ postParams: seckillFormData })
					.then((res) => {
						loading.close();
						if (res) {
							this.$message.success(`${id === "0" ? "发布" : "编辑"}成功`);
							setTimeout(() => {
								this.goBack();
							}, 500);
						}
					})
					.catch(() => {
						loading.close();
					});
			}
		});
	}

	/**
	 * 返回列表页
	 * @return null
	 */
	public goBack(): void {
		this.$router.go(-1);
	}

	/* 周期 */
	empCode = "";
	seckKillCode = "";
	isOpenSkCart = 0;
	public created(): void {
		this.empCode = localStorage.getItem("empCode") || "";
		this.isCopy = +this.$route.query.isCopy || 0;
		this.platformVersion = +localStorage.getItem("platformVersion");
		this.isOpenSkCart = +localStorage.getItem("isOpenSkCart") || 0;
		this.seckKillCode = this.$route.query.empCode as string;
		if (this.$route.params.id !== "0") {
			this.getSecKillDetail(); // 获取秒杀详情
		}
	}

	onDeletePic(key) {
		this.seckillForm[key] = "";
	}

	onMagnifyPic(key) {
		ImgPreview.open({ img: this.seckillForm[key] });
	}

	/**
	 * 验证是否有编辑完未保存的商品
	 */
	public validateIsEdit(val) {
		return val._edit === true;
	}

	/**
	 * 批量设置库存价格
	 */
	public batchSet() {
		if (!this.seckillForm.list.length) {
			return false;
		}
		const data = this.seckillForm.list.flatMap((v) => {
			return v.skuItems.map((s) => {
				return {
					productCode: v.productCode,
					sku: s.sku,
					specVal: s.specVal,
					price: s.price,
					stock: s.stock,
				};
			});
		});
		importBatchSet
			.open({
				title: "批量配置库存价格",
				fromKey: "skill",
				postParams: { skIds: this.seckillForm.list.map((v) => v.skId) },
				empCode: this.$store.state.empCode,
				data,
				excelHeader: this.excelHeader,
			})
			.then((result) => {
				if (result.flag) {
					const updateItems = groupBy(result.result, "productCode");
					Object.keys(updateItems).forEach((e) => {
						this.seckillForm.list = this.seckillForm.list.map((s) => {
							if (s.productCode === e) {
								s.skuItems = s.skuItems.map((sk) => {
									const temp = updateItems[e].find((es) => es.sku === sk.sku);
									if (temp) {
										sk.price = temp.price;
										sk.stock = temp.stock;
									}
									return sk;
								});
							}
							return s;
						});
					});
				}
			}, noop);
	}

	/**
	 * 根据筛选条件
	 */
	setCondition(e) {
		if (this.seckillForm.siteCodes.length) {
			const siteId = +localStorage.getItem("siteId") || +localStorage.getItem("firstSiteId");
			e.stopPropagation();
			const protocol = `${location.protocol}//`;
			let hostName = location.hostname;
			hostName.includes("host") && (hostName = "ips.maintenance.qingger.cn");

			IPSService.siteGroupConfig({
				postParams: {
					siteId,
					sgId: +this.$route.params.sgId || +this.$route.params.id,
				},
			}).then((res) => {
				client
					.pick({
						path: "customer-predicate",
						dialogStyle: { width: "50vw", height: "100vh", backgroudColor: "#eee", zIndex: 99999999999 },
						modelDialog: true,
						slide: "left",
						props: {
							params: { actId: res.actId || 2 },
							zIndex: 99999999999,
							id: this.condition.id,
							exclude: ["#root.crmPublicAccounts"],
						},
						domain: `${protocol + hostName}/scrm/web`,
						cancel: true,
						search: `?baseURL=/nips/scrm&ext_ips__auth_token=${this.tokenData.Authorization}&ext_ips__site=${siteId}`,
					})
					.then((r: any) => {
						this.condition = r;
						this.seckillForm.receiptConfig.id = this.condition.id ? this.condition.id : "";
					});
			});
		} else {
			this.$message.warning("请先选择网点");
		}
	}

	getConditionText() {
		if (!this.condition.id) {
			return;
		}
		IPSService.customerCondition({
			queryParams: {
				id: this.condition.id,
				EXT_IPS__SITE: this.siteId ? this.siteId : "",
			},
		}).then((response) => {
			let length = 0;
			(response.conditions || []).forEach((val) => {
				const orLength = val.or ? val.or.length : 0;
				const andLength = val.and ? val.and.length : 0;
				length = length + orLength + andLength;
			});
			this.condition.text = `已选择${length}个条件`;
		});
	}
	/**
	 * 清空限制条件
	 */
	closeCondition() {
		this.condition.id = "";
		this.condition.text = "";
		this.seckillForm.receiptConfig.id = "";
	}

	/**
	 * 切换参与门槛
	 */
	changeReceiptConfig() {
		if (this.seckillForm.receiptConfig.type == 0) {
			this.closeCondition();
		}
	}
}
